function initIlluAnimations() {
    const $liveAmMittwuch = $('.default-modal #live-am-mittwuch');
    const $wimper1 = $('.default-modal #wimper1');
    const $wimper2 = $('.default-modal #wimper2');
    const $wimper3 = $('.default-modal #wimper3');
    const $wimper4 = $('.default-modal #wimper4');
    const $wimper5 = $('.default-modal #wimper5');
    const $wimper6 = $('.default-modal #wimper6');
    const $wimper7 = $('.default-modal #wimper7');
    const $wimper8 = $('.default-modal #wimper8');
    const $auge = $('.default-modal #auge');
    const $soundsAmDunnstig = $('.default-modal #sounds-am-dunnstig');
    const $tanzAmSunntig = $('#tanz-am-sunntig');
    const $linie1 = $('#linie1');
    const $linie2 = $('#linie2');
    const $linie3 = $('#linie3');
    const $linie4 = $('#linie4');
    const $linie5 = $('#linie5');
    const $linie6 = $('#linie6');
    const $fuss = $('#fuss');

    TweenMax.set([
        $wimper1,
        $wimper2,
        $wimper3,
        $wimper4,
        $wimper5,
        $wimper6,
        $wimper7,
        $wimper8,
        $auge,
    ], {
        transformOrigin: "50% 50%"
    });

    var timelineMittwuch = new TimelineLite();

    timelineMittwuch.pause();

    var wimper1 = TweenMax.fromTo($wimper1, 0.2, {
        rotation: 10,
    }, {
        rotation: -15,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var wimper2 = TweenMax.fromTo($wimper2, 0.3, {
        rotation: -10,
    }, {
        rotation: 15,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeIn,
        yoyo: true,
        immediateRender: false,
    });

    var wimper3 = TweenMax.fromTo($wimper3, 0.25, {
        rotation: 13,
    }, {
        rotation: -10,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var wimper4 = TweenMax.fromTo($wimper4, 0.3, {
        rotation: 10,
    }, {
        rotation: -13,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var wimper5 = TweenMax.fromTo($wimper5, 0.2, {
        rotation: 10,
    }, {
        rotation: -15,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var wimper6 = TweenMax.fromTo($wimper6, 0.25, {
        rotation: 13,
    }, {
        rotation: -10,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var wimper7 = TweenMax.fromTo($wimper7, 0.3, {
        rotation: -10,
    }, {
        rotation: 15,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeIn,
        yoyo: true,
        immediateRender: false,
    });

    var wimper8 = TweenMax.fromTo($wimper8, 0.2, {
        rotation: 10,
    }, {
        rotation: -15,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var auge = TweenMax.fromTo($auge, 0.3, {
        rotation: 5,
    }, {
        rotation: -5,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    timelineMittwuch.add(wimper1, 0);
    timelineMittwuch.add(wimper2, 0);
    timelineMittwuch.add(wimper3, 0);
    timelineMittwuch.add(wimper4, 0);
    timelineMittwuch.add(wimper5, 0);
    timelineMittwuch.add(wimper6, 0);
    timelineMittwuch.add(wimper7, 0);
    timelineMittwuch.add(wimper8, 0);
    timelineMittwuch.add(auge, 0);

    // hover
    $($liveAmMittwuch).mouseenter(function () {
        // timeline start
        timelineMittwuch.resume();
    }).mouseleave(function () {
        // timeline stop
        timelineMittwuch.pause();
    });


    var timelinedunnstig = new TimelineLite();

    timelinedunnstig.pause();

    var soundsamdunnstig = TweenMax.fromTo($soundsAmDunnstig, 0.3, {
        rotation: 5,
    }, {
        rotation: -5,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    timelinedunnstig.add(soundsamdunnstig, 0);

    $($soundsAmDunnstig).mouseenter(function () {
        // timeline start
        timelinedunnstig.resume();
    }).mouseleave(function () {
        // timeline stop
        timelinedunnstig.pause();
    });


    var timelinesunntig = new TimelineLite();

    timelinesunntig.pause();

    var linie1 = TweenMax.fromTo($linie1, 0.25, {
        rotation: 10,
    }, {
        rotation: -15,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var linie2 = TweenMax.fromTo($linie2, 0.3, {
        rotation: 10,
    }, {
        rotation: -13,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var linie3 = TweenMax.fromTo($linie3, 0.27, {
        rotation: 12,
    }, {
        rotation: -6,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var linie4 = TweenMax.fromTo($linie4, 0.3, {
        rotation: -17,
    }, {
        rotation: 12,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var linie5 = TweenMax.fromTo($linie5, 0.3, {
        rotation: 5,
    }, {
        rotation: -10,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var linie6 = TweenMax.fromTo($linie6, 0.27, {
        rotation: -13,
    }, {
        rotation: 11,
        transformOrigin: '50% 50%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    var fuss = TweenMax.fromTo($fuss, 0.27, {
        rotation: -1,
    }, {
        rotation: 2,
        transformOrigin: '0% 0%',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true,
        immediateRender: false,
    });

    timelinesunntig.add(linie1, 0);
    timelinesunntig.add(linie2, 0);
    timelinesunntig.add(linie3, 0);
    timelinesunntig.add(linie4, 0);
    timelinesunntig.add(linie5, 0);
    timelinesunntig.add(linie6, 0);
    timelinesunntig.add(fuss, 0);

    $($tanzAmSunntig).mouseenter(function () {
        // timeline start
        timelinesunntig.resume();
    }).mouseleave(function () {
        // timeline stop
        timelinesunntig.pause();
    });

}

$(function () {
    $(window).on('default-modal:opened', function () {
        initIlluAnimations();
    });
});



// WEBPACK FOOTER //
// ./static/js/modules/menu-illus.js